module.exports = __webpack_public_path__ + "static/assets/baa7be5af0323a17a32949caf4cb9307.svg";